import { styled } from "styled-components";

const Container = styled.div`
  display: flex;
  width: 100vw;
  gap: 0.75rem;

  padding: 0 1rem;
  scroll-snap-type: x mandatory;
  overflow-x: auto;

  & > * {
    scroll-snap-align: center;
    width: calc(-2rem + 100vw);
    flex-shrink: 0;
  }
`;

export default { Container };
